export enum AppointmentStatusCode {
  EXPIRED = 'EXPIRED',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
  DECLINING = 'DECLINING',
  PENDING = 'PENDING'
}

export interface GetAppointmentResponse {
  clientName?: string;
  serviceName?: string;
  centerDetails?: string;
  appointmentDateTime?: string;
  appointmentId: string;
  appointmentDate?: string;
  appointmentTime?: string;
  clientAttendanceResponseStatus: AppointmentStatusCode;
  cancellationReasonCode?: AppointmentCancellationReason;
  cancellationOtherReason?: string;
  businessUnit?: string;
}

export const AAC_BUSINESS_UNIT = 'AAC';

// Befriending & Buddying (BnB) appointments are handled by a Befriender instead of a Care Coordinator
const BNB_SERVICE_NAME_PATTERN = /befriending|buddying/i;

export const getAppointmentContactTerm = (serviceName?: string): string =>
  serviceName && BNB_SERVICE_NAME_PATTERN.test(serviceName) ? 'Befriender' : 'Care Coordinator';

export enum AppointmentClientResponse {
  DECLINED = 'DECLINED',
  CONFIRMED = 'CONFIRMED'
}

export enum AppointmentCancellationReason {
  HOSPITALISATION = 'HOSPITALISATION',
  CLIENT_UNWELL = 'CLIENT_UNWELL',
  CLIENT_PASSED_AWAY = 'CLIENT_PASSED_AWAY',
  OTHER = 'OTHER'
}

export interface UpdateAppointment {
  appointmentId?: string;
  clientResponse?: AppointmentClientResponse;
  clientResponseMethod: 'SMS';
  linkId: string;
  cancellationReason?: string;
  cancellationOtherReason?: string;
}

export interface AppointmentState {
  loading: boolean;
  data?: GetAppointmentResponse;
  showSomethingWentWrong?: boolean;
}
